
import { showModal } from '@/plugins/vue-final-modal'
import { Task } from '@/types/api/task'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  props: {
    task: { type: Object as PropType<Task>, required: true }
  },
  setup() {
    return {
      showModal
    }
  }
})

